import { FC, useEffect } from "react";
import { SidebarLinkTypes } from "../../LinkTypes";
import { CoinsIcon } from "../../../../assets/icons/Icons";
import { BaseComplexSidebarLink, ComplexLinkProps } from "./BaseComplexSidebarLink";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../../../hooks/StoreHooks";
import { useActionsData } from "../../../../store/selectors/actionModulesSelectors";
import { fetchActionModules } from "../../../../store/thunk/actionsModulesThunk";

export const IncentivationComplexLink: FC<ComplexLinkProps> = ({
    activePathname,
    collapsed,
    showText = true,
}) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const actionModules = useActionsData();
    useEffect(() => {
        dispatch(fetchActionModules());
    }, [dispatch]);
    const links = actionModules?.map(a => ({
        name: a.name,
        path: `incentivation/actionModules/${a.id}`,
    })) ?? [];
    if (!links.length) return null;
    return (
        <BaseComplexSidebarLink
            activePathname={activePathname}
            collapsed={collapsed}
            showText={showText}
            icon={<CoinsIcon color="white" />}
            label={t(SidebarLinkTypes.incentivation)}
            links={links}
        />
    );
};